import { PureComponent } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import VerifyStep from './VerifyStep';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class GoToInboxRow extends PureComponent {
  renderButton() {
    const {
      onConfirm
    } = this.props;
    return /*#__PURE__*/_jsx(UIButton, {
      use: "tertiary",
      size: "small",
      onClick: onConfirm,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "MessagesApp.verifyFbmPrompt.stepTwo.button"
      })
    });
  }
  render() {
    return /*#__PURE__*/_jsx(VerifyStep, {
      button: this.renderButton(),
      children: /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx("span", {
          className: "is--heading-5 m-bottom-2",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "MessagesApp.verifyFbmPrompt.stepTwo.header"
          })
        }), /*#__PURE__*/_jsx("p", {
          className: "m-bottom-0",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "MessagesApp.verifyFbmPrompt.stepTwo.body"
          })
        })]
      })
    });
  }
}
GoToInboxRow.displayName = 'GoToInboxRow';
export default GoToInboxRow;